


















































































import { Vue, Component, Watch } from 'vue-property-decorator';
import ClaimLogComponent from "@/components/vcponlineok/staff-user/claim-log-component.vue";
import NewLogEntryComponent from "@/components/vcponlineok/staff-user/new-log-entry-component.vue";
import bus from '@/components/vcponlineok/bus/bus.js';
import { VcClaimLogDto } from '@/asdcom/apiproxy/apiproxy.dto';
import ClaimViewBaseComponent from './ClaimViewBaseComponent';
import util from '@/lib/util';

interface ITableRow {
  id: string | number,
  submittedDate: string,
  status: string
}

@Component({
  components: {
    ClaimLogComponent,
    NewLogEntryComponent
  }
})
export default class ClaimLog extends ClaimViewBaseComponent {
  loading: boolean = false;
  isItemView: boolean = false;
  componentName: string | null = null;
  filterModel: any[] = [];
  logItem: any = {};
  originalLogData: VcClaimLogDto[] = [];
  filteredLogData: VcClaimLogDto[] = [];
  logItemTypes: any[] = util.abp.constant.eventType.values;
    
  async created() {
    this.getVcClaimLogs();
    if (this.$route.params.reminder == "reminder") {
      this.componentName = "NewLogEntryComponent";
      this.isItemView = true;
    }
  }

  mounted() {
    bus.$on("newLogEntry", () => {
      this.openNewLogEntry();
    })
    bus.$on("toListView", () => {
      this.isItemView = false;
      this.logItem = {};
    })
  }
  destroyed() {
    bus.$off("newLogEntry");
    bus.$off("toListView");
  }

  @Watch("filterModel")
  isFilterChanged() {
    this.filteredLogData = [];
    if (!!this.filterModel && this.filterModel.length > 0) {
      this.filteredLogData = this.originalLogData.filter(v => {
        return this.filterModel.some(i => v.eventType == i.value);
      })
    } else {
      this.filteredLogData = this.originalLogData;
    }
  }

  removeFilterItem(item: any) {
    this.filterModel.splice(this.filterModel.indexOf(item), 1)
    this.filterModel = [...this.filterModel]
  }

  async getVcClaimLogs() {
    this.originalLogData = await this.$appsvs.vcpOnlineOkStaff.retrieveVcClaimLogs(this.vcClaimNumber);
    this.filteredLogData = this.originalLogData;
  }

  editLogItem(item: any) {
    this.logItem = item;
    this.$router.push({name: "ClaimLog", params: {id: item.id}})
    this.componentName = "ClaimLogComponent";
    this.isItemView = true;
  }

  openNewLogEntry() {
    if (this.$route.name !== " ClaimLog" && this.$route.params.reminder !== "reminder") {
      this.$router.push({name: "ClaimLog", params: {reminder: "reminder"}});
    }
    this.componentName = "NewLogEntryComponent";
    this.isItemView = true;
  }

  closeItem() {
    this.getVcClaimLogs();
    this.$router.replace({name: "ClaimLog"});
    this.logItem = {};
    this.isItemView = false;
  }
}
